import axios from 'axios';
import { getApiUrl } from '../../../settings';
import { getAccessToken } from '../../authApi';

export const getSellers = async () => {
  const bearerToken = getAccessToken();
  const apiUrl = await getApiUrl();

  const response = await axios.request({
    method: 'GET',
    url: `${apiUrl}/api/v1/sellers?quantityPerPage=100000`,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    },
  });

  return response;
};

export default getSellers;
